import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { EventsPage as EventsInner } from "./Events";
import { FalseFlagsPage as FlaggedInner } from "./FalseFlags";

type Tab = "events" | "flagged";

/** Merged Events page. Default tab shows the full event log; "Flagged"
 *  tab is the false-flag review queue (admin-only workflow, same as the
 *  old /false-flags page). One sidebar entry, two linked views. */
export function EventsShell() {
  const location = useLocation();
  const navigate = useNavigate();

  const initial: Tab =
    location.pathname === "/false-flags" || location.search.includes("tab=flagged")
      ? "flagged"
      : "events";
  const [tab, setTab] = useState<Tab>(initial);

  function switchTab(next: Tab) {
    setTab(next);
    const base = "/events";
    navigate(next === "flagged" ? `${base}?tab=flagged` : base, { replace: true });
  }

  return (
    <>
      <div className="sg-subnav">
        <button
          type="button"
          className={`sg-subnav-item${tab === "events" ? " active" : ""}`}
          onClick={() => switchTab("events")}
        >
          Events
        </button>
        <button
          type="button"
          className={`sg-subnav-item${tab === "flagged" ? " active" : ""}`}
          onClick={() => switchTab("flagged")}
          title="User-reported false positives"
        >
          Flagged
        </button>
      </div>
      {tab === "events" ? <EventsInner /> : <FlaggedInner />}
    </>
  );
}
